module.exports = __webpack_public_path__ + "static/media/Milad-Mosadegh-CV.da8bc375.pdf";